import { FC, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import { useAppSelector } from 'hooks/useStore';
// Types
import QuizTypes from 'types/QuizTypes';
// Seletors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import { Button } from 'components/Buttons';

const AlreadyPassedPage:FC = () => {
  const navigateTo = useNavigateTo();
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const email = queryParams.get('email');

  const quiz = useAppSelector(selectQuiz);

  const isPollQuiz = quiz.type === QuizTypes.Poll;

  return (
    <Fragment>
      <PublicDevicePlayable />
      <div
        className="flex-1"
        style={{ background: isPollQuiz && quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
      >
        <AppBar />
        {isPollQuiz ? <div className="h-24" />  : null}
        <div className={`grow p-4 overflow-y-auto ${isPollQuiz ? 'text-white' : ''}`}>
          <h2 className={`text-center ${isPollQuiz ? 'text-xl' : 'text-md'}`}>
            {`You already passed this ${isPollQuiz ? 'poll' : 'quiz'} as`}
          </h2>
          <h2 className={`font-bold text-center mb-4 ${isPollQuiz ? 'text-xl' : 'text-md'}`}>
            {email}
          </h2>
          <h2 className={`text-center mb-6 ${isPollQuiz ? 'text-xl' : 'text-md'}`}>
            {`Please click button below to see ${isPollQuiz ? 'results' : 'your score'}.`}
          </h2>
          <div className="text-center">
            <Button
              disableShadow={isPollQuiz}
              className={`
                ${isPollQuiz
                  ? 'w-full text-2xl uppercase text-[#282728] bg-gradient-to-b from-[#facc22] to-[#f83600] hover:from-[#f83600] hover:to-[#facc22]'
                  : 'capitalize text-black'
                }
              `}
              onClick={() => navigateTo('post-quiz')}
            >
              {`Show ${isPollQuiz ? 'Results' : 'Score'}`}
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AlreadyPassedPage;
